import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import headerImage from '../../services/headerImage';
import BrandingProp from '../propTypes/brandingProp';

const imageFromBranding = (branding, isResponsive) => {
  const brandingImage = isResponsive
    ? branding.headBackgroundResponsive
    : branding.headBackground;
  return brandingImage ? `url(${brandingImage})` : headerImage(branding);
};

export default function HeadBackground(props) {
  const { branding, children, pageBodyClass } = props;

  const [backgroundImage, setBackgroundImage] = useState(
    imageFromBranding(branding, false),
  );

  useEffect(() => {
    let query;
    const handler = result =>
      setBackgroundImage(imageFromBranding(branding, result.matches));
    if (typeof window !== 'undefined') {
      query = window.matchMedia('(max-width: 768px)');
      query.addEventListener('change', handler);
    }
    return () => {
      query.removeEventListener('change', handler);
    };
  }, []);

  let style = {
    backgroundImage,
  };
  let wrapperClass = '';

  if (branding && branding.headBackground) {
    style = {
      ...style,
      objectFit: 'cover',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
    };
    wrapperClass = 'background-headers-fix';
  }

  if (pageBodyClass) {
    wrapperClass += ` ${pageBodyClass}`;
  }

  const backgroundClassName = `m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body ${wrapperClass}`;

  return (
    <div className={backgroundClassName} style={style}>
      {children}
    </div>
  );
}

HeadBackground.propTypes = {
  branding: PropTypes.shape(BrandingProp.propTypes).isRequired,
  children: PropTypes.node.isRequired,
  pageBodyClass: PropTypes.string,
};

HeadBackground.defaultProps = {
  pageBodyClass: undefined,
};
